import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingSection = ({ packages, onSelectPackage }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 lg:p-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-headline font-bold text-foreground mb-4">
          Service Packages
        </h3>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
          Transparent pricing with flexible options to match your needs
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {packages?.map((pkg, index) => (
          <div
            key={index}
            className={`relative rounded-2xl border-2 p-6 md:p-8 transition-all duration-300 hover:shadow-elevated ${
              pkg?.popular 
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            {pkg?.popular && (
              <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                <span className="px-4 py-1.5 bg-primary text-primary-foreground text-sm font-medium rounded-full shadow-lg">
                  Most Popular
                </span>
              </div>
            )}

            <div className="text-center mb-6">
              <h4 className="text-xl md:text-2xl font-headline font-bold text-foreground mb-2">
                {pkg?.name}
              </h4>
              <p className="text-sm text-muted-foreground mb-4">
                {pkg?.description}
              </p>
              <div className="flex items-baseline justify-center gap-2">
                <span className="text-4xl md:text-5xl font-headline font-bold text-foreground">
                  {pkg?.price}
                </span>
                {pkg?.period && (
                  <span className="text-base text-muted-foreground">
                    /{pkg?.period}
                  </span>
                )}
              </div>
            </div>

            <div className="space-y-4 mb-8">
              {pkg?.features?.map((feature, featureIndex) => (
                <div key={featureIndex} className="flex items-start gap-3">
                  <Icon 
                    name={feature?.included ? "CheckCircle2" : "XCircle"} 
                    size={20} 
                    color={feature?.included ? "var(--color-success)" : "var(--color-muted-foreground)"} 
                    className="flex-shrink-0 mt-0.5"
                  />
                  <span className={`text-sm ${feature?.included ? 'text-foreground' : 'text-muted-foreground line-through'}`}>
                    {feature?.text}
                  </span>
                </div>
              ))}
            </div>

            <Button
              variant={pkg?.popular ? "default" : "outline"}
              size="lg"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => onSelectPackage(pkg)}
            >
              {pkg?.ctaText}
            </Button>
          </div>
        ))}
      </div>
      <div className="mt-8 p-6 bg-muted rounded-xl text-center">
        <p className="text-sm text-muted-foreground mb-4">
          Need a custom solution? We offer tailored packages for clubs and organizations.
        </p>
        <Button
          variant="ghost"
          size="sm"
          iconName="MessageCircle"
          iconPosition="left"
        >
          Contact for Enterprise Pricing
        </Button>
      </div>
    </div>
  );
};

export default PricingSection;